// extracted by mini-css-extract-plugin
export default {"mainContainer":"Loader_mainContainer__Engi4","ldsDefault":"Loader_ldsDefault__o63T+","lds-default":"Loader_lds-default__xe+13"};